import Config from 'config';
import { IApiaForm } from '../../../../JSApi/types';
import { TFncParams } from '../../../../types';
import { formatMessage } from '../../../../utils/util';
import { notify } from '../../../common/notifications/util';

export const parseEvtId = (evtId?: string | number): number | null => {
  let id;
  if (typeof evtId === 'string' && evtId !== undefined) {
    id = parseInt(evtId, 10);
  } else if (typeof evtId === 'number' && evtId !== undefined) {
    id = evtId;
  }
  return id || null;
};

export const getFunctionParams = (
  fncParams: TFncParams[],
  form: IApiaForm | null,
): unknown[] => {
  const fncParamsArray = [];
  for (let e = 0; e < fncParams.length; e += 1) {
    if (fncParams[e].type === 'V') {
      fncParamsArray.push(fncParams[e].value);
    } else if (fncParams[e].type === 'E' || fncParams[e].type === 'P') {
      const paraAttId = fncParams[e].attId;
      if (paraAttId) {
        fncParamsArray.push(form?.getAttField(paraAttId));
      }
    }
  }
  return fncParamsArray;
};

export const showScriptFnErrorMessage = (fncName: string): void => {
  // console.error('error:', fncName);
  const errMsg = formatMessage(Config.ERR_EXEC_BUS_CLASS, {
    TOK1: fncName,
  });
  notify({
    message: errMsg,
    type: 'danger',
  });
};
